/**
 * Conversation UI event names and helpers.
 */

export const conversationEvents = {
  openOptions: 'openConversationOptions',
  openSettings: 'openConversationSettings',
  openNewConversationModal: 'openNewConversationModal',
  command: 'xavior:conversation-command',
  moduleFocused: 'xavior:module-focused',
  setSidebarCollapsed: 'xavior:set-sidebar-collapsed',
  // Command (sidebar → chat): close the open module pane and drop to chat-only.
  closeModulePane: 'xavior:close-module-pane',
  // Notification (chat → outward): the module pane is no longer showing.
  // Fire-and-forget — the rail no longer listens (ADR 028: its highlight
  // derives from ModulePaneContext and toggle-close gates on the rendered
  // confirmation). User-intent and cleanup close paths (pane close button,
  // rail toggle-close via hideModulePane, the missing-module auto-clear)
  // dispatch it so external tooling/tests get a uniform pane-closed signal;
  // background hydration seeds are exempt.
  modulePaneClosed: 'xavior:module-pane-closed',
} as const;

export function addWindowListener(
  eventName: string,
  listener: EventListener,
): void {
  window.addEventListener(eventName, listener);
}

export function removeWindowListener(
  eventName: string,
  listener: EventListener,
): void {
  window.removeEventListener(eventName, listener);
}

export function dispatchWindowEvent(
  eventName: string,
  detail?: unknown,
): void {
  window.dispatchEvent(new CustomEvent(eventName, { detail }));
}
